// shiftData.js
// Shift configuration constants used throughout the application

export const SHIFT_CONFIGS = {
  'Weekend Morning': {
    shiftsPerWeek: 2,
    startTime: '08:15 AM',
    endTime: '12:00 PM',
    workingDays: [0, 6], // Sunday=0, Saturday=6
    description: 'Saturday & Sunday mornings'
  },
  'Weekend Afternoon': {
    shiftsPerWeek: 2, 
    startTime: '03:00 PM',
    endTime: '06:30 PM',
    workingDays: [0, 6], // Sunday=0, Saturday=6
    description: 'Saturday & Sunday afternoons'
  },
  'After School': {
    shiftsPerWeek: 5,
    startTime: '04:30 PM',
    endTime: '07:30 PM',
    workingDays: [1, 2, 3, 4, 5], // Monday-Friday
    description: 'Monday through Friday after school'
  },
  'Summer Morning': {
    shiftsPerWeek: 5,
    startTime: '09:00 AM',
    endTime: '12:00 PM',
    workingDays: [1, 2, 3, 4, 5], // Monday-Friday  
    description: 'Monday through Friday summer mornings'
  },
  'Summer Afternoon': {
    shiftsPerWeek: 5,
    startTime: '04:00 PM',
    endTime: '08:00 PM',
    workingDays: [1, 2, 3, 4, 5], // Monday-Friday
    description: 'Monday through Friday summer afternoons'
  }
};

// Array of shift names for dropdowns and selects
export const shiftOptions = Object.keys(SHIFT_CONFIGS);

// Helper function to get shift configuration by name
export const getShiftConfig = (shiftName) => {
  return SHIFT_CONFIGS[shiftName] || null;
};

// Helper function to check if a shift exists
export const isValidShift = (shiftName) => {
  return shiftName in SHIFT_CONFIGS;
};

